import { IUserTeamQuery } from '../interfaces/user-team.query.interface';
import { Team } from './team.model';

export class UserTeam {
    category: string;
    teams: Team[];

    constructor(teamQuery: IUserTeamQuery) {
        this.category = teamQuery.category;
        this.teams = teamQuery.teams.length ? teamQuery.teams.map((team) => new Team(team)) : [];
    }
}
